/**
 * Layout component contains header and footer
 *
 * @package gatsby-wordpress-theme
 */
import React, { useEffect } from "react"
import PropTypes from "prop-types"
// import { navigate } from 'gatsby';
import Cookies from 'js-cookie'; // Assicurati di installare js-cookie con npm o yarn
import { I18nextProvider } from "react-i18next"
import i18n from "§/i18n"
import "§/src/fonts/fonts.css"
import "§/src/sass/theme.scss"
import "§/src/sass/layout/layout.scss"
// import { scrollToTop } from "§/src/utils/scrollToTop";
// import DevGrid from "../_dev/grid";
import Header from "../header"
import Footer from "../footer"

const Layout = ({ 
  children,
  data,
  className,
  containerExtraClass = '',
  breadcrumbs,
  lang,
  langReplace,
  container
}) => {
  useEffect(() => {
    // Controlla se il cookie del reindirizzamento linguistico esiste già
    const hasRedirected = Cookies.get('langRedirected');

    if (!hasRedirected && lang) {
      const userLang = navigator.language || navigator.userLanguage;
      const siteLang = lang?.locale?.locale;
      const translation = lang?.translations?.[0]?.href;

      if (userLang !== "it-IT" && siteLang === "it_IT" && translation) {
        // Filtra l'URL di reindirizzamento se necessario
        const filteredHref = translation === "/en/home/" ? "/en/" : translation;

        // Imposta un cookie per ricordare che l'utente è stato reindirizzato
        Cookies.set('langRedirected', 'true', { expires: 7 }); // Il cookie scade dopo 7 giorni

        setTimeout(() => {
          window.location.replace(filteredHref);
        }, 500); // Ritardo di 500 millisecondi
      }
    }
  }, [lang]); // Aggiungi lang come dipendenza dell'effetto

  const containerClass = `main-container bg-dark-red ${container === 'full' ? '' : 'container-max'} ${containerExtraClass}`;

  return (
    <I18nextProvider i18n={i18n}>
      <Header lang={lang} langReplace={langReplace} className={className} data={data} breadcrumbs={breadcrumbs} />
      <main className={containerClass}>{children}</main>
      <Footer lang={lang} langReplace={langReplace} data={data} />
    </I18nextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
